var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.childrenMenu),function(v){return (v.hiden == 1)?_c('div',{key:v.id,staticClass:"level2",class:{ active: '/' + v.path == _vm.path },on:{"click":function($event){return _vm.goLink(v)}}},[_vm._v("\n    "+_vm._s(v.title)+"\n  ")]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }